import { Component } from '@angular/core';
import { ViewController, NavParams, ModalController, App } from 'ionic-angular';
import { FormBuilder, Validators } from '@angular/forms';

import { ReviseMoneyPage } from './reviseMoney';

import { PasswordService } from './../../services/password.service';
import { LoaddingService } from './../../providers/loadding.service';
import { StorageService } from './../../providers/storage.service';
import { AlertService } from './../../providers/alert.service';
import { UserVarifyService } from '../../services/userVarify.service';
import { UserModel } from './../../models/user.model';

import { AppConfig } from '../../app/app.config';
import { UserList } from '../signin/agreemsg';
import { SigninPage } from '../signin/signin';
import { SigninService } from '../../services/signin.service';

@Component({
  selector: 'page-revise',
  templateUrl: 'revise.html',
  providers: [
    PasswordService,
    AlertService,
    UserVarifyService
  ]
})
export class RevisePage {
  AppConfig = AppConfig;
  user: UserModel;
  information: number = 0;
  titleName: string;
  flag: boolean = true;
  revisment = [
    { id: 0, name: '修改登录密码' },
    { id: 1, name: '创建资金密码' },
    { id: 2, name: '修改资金密码' }
  ];
  Question = [
    { title: 'Question1', value: '' },
    { title: 'Question2', value: '' },
    { title: 'Question3', value: '' }
  ];

  constructor(
    public navParams: NavParams,
    private ViewCtrl: ViewController,
    private reviseService: PasswordService,
    private alert: AlertService,
    private loadding: LoaddingService,
    private storage: StorageService,
    private userService: UserVarifyService,
    public modalCtrl: ModalController,
    private app: App,
    private signinService: SigninService,
    private formBuilder: FormBuilder
  ) {
    if (this.navParams.get("information")) {
      this.information = this.navParams.get("information");
    } else {
      this.information = 0;
    }
    this.revisment.forEach(s => {
      if (s.id == this.information) {
        this.titleName = s.name;
      }
    });
  }

  setLoginForm = this.formBuilder.group({
    'old': ['', [Validators.required]],
    'newOne': ['', [Validators.required]],
    'newTwo': ['', [Validators.required]]
  });

  newForm = this.formBuilder.group({
    'newOne': ['', [Validators.required]],
    'newTwo': ['', [Validators.required]]
  });

  checkSafeForm = this.formBuilder.group({
    'Name': this.AppConfig.User.UserName,//this.user.UserName,
    'Pwd': '',
    'PwdOk': '',
    'Answer1': ['', [Validators.required]],
    'Answer2': ['', [Validators.required]],
    'Answer3': ['', [Validators.required]]
  });
  ionViewDidLoad() {
    this.user = this.storage.read<UserModel>("User");
    this.userService.getMiBaoQuestion({ Name: this.user.UserName }).then(s => {
      this.Question[0].value = s.Question1;
      this.Question[1].value = s.Question2;
      this.Question[2].value = s.Question3;
    })
  }


  //设置资金密码
  //chen 2017-06-06
  setMoney(obj) {
    if (obj.newOne == obj.newTwo) {
      this.reviseService.getCreateMoney({ UserName: this.user.UserName, OldPwd: obj.newOne, NewPwd: obj.newOne }).then(s => {
        this.storage.localStorageSet('isBindPassword', s['Result']);
        this.alert.showAlert(s.Error);
        this.ViewCtrl.dismiss(s.Result);
      });
    } else {
      this.alert.showAlert("新密码前后不一致，请重新输入");
    }
  }

  //修改登录密码
  //chen 2017-06-06
  reviseLogin(obj) {
    this.signinService.checkIsSimplePwd({ userpwd: obj.newOne }).then(les => {
      if (les.Result) {
        this.alert.showAlert('您的密码过于简单，请重新设置（纯数字；单个字母加连贯数字；与账户相同的密码都为简单密码）！');
        return;
      }
      if (obj.newOne == obj.newTwo) {
        this.reviseService.getReviseLogin({ UserName: this.user.UserName, OldPwd: obj.old, NewPwd: obj.newOne }).then(s => {
          if (this.storage.readString("Users") && this.storage.readString("Users") != '[]') {
            const userArrStr = AppConfig.decodeBase64(this.storage.readString("Users"));
            let storageusers: UserList[] = JSON.parse(userArrStr);
            if (storageusers && storageusers.length > 0) {
              storageusers.forEach((v) => {
                if (v.username === this.user.UserName) {
                  v.pwd = obj.old;
                }
              });
              this.storage.writeString("Users", AppConfig.encodeBase64(JSON.stringify(storageusers)));
            }
          }
          this.alert.showAlert(s.Error);
          this.ViewCtrl.dismiss();
          let timer = setTimeout(() => {
            this.storage.clear();
            this.app.getRootNav().setRoot(SigninPage);
            clearTimeout(timer);
          }, 2000);
        });
      } else {
        this.alert.showAlert("新密码前后不一致，请重新输入");
      }
    }).catch(err => { });
  }

  //验证密保问题
  //chen 2017-06-06
  checkSafe(obj) {
    this.userService.ckUserQuestion(obj).then(s => {
      if (s.Result == -1) {
        this.alert.showAlert(s.Error);
        return;
      } else {
        this.ViewCtrl.dismiss();
        let modal = this.modalCtrl.create(ReviseMoneyPage);
        modal.present();
      }
    })
  }


  //页面关闭
  //chen 2017-03-13
  dismiss() {
    const userPassword = this.storage.readString("userpwd");
    let password = null;
    if (userPassword) {
      password = AppConfig.decodeBase64(this.storage.readString("userpwd"));
    }
    if (AppConfig.User && !AppConfig.User.GASecret) {
      this.signinService.checkIsSimplePwd({ userpwd: password }).then(s => {
        if (s.Result) {
          this.alert.showAlert('您的密码过于简单，请重新设置（纯数字；单个字母加连贯数字；与账户相同的密码都为简单密码）！')
          return;
        }
        this.ViewCtrl.dismiss(false);
      })
    } else {
      this.ViewCtrl.dismiss(false);
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/password/revise.ts